import React, {useState,useEffect} from 'react';
import {Redirect,Link} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import Hidden from '@mui/material/Hidden';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import {Inc,Owner,OwnerBank} from './Inc';
import ColInput from './ColInput';
import RowData from './RowData';
import Yesno from './Yesno';
import Ajax from './Ajax';
import Toast from './Toast';
import BottomButtons from './BottomButtons';
import {Tools} from './Tools';
import Title from './Title';
import Loading from './Loading';

interface Props {
    owner:Owner,
}

let errors:string[] = [];

const BankInput = (props:Props)=> {
    Ajax.setEditorId( props.owner.owner_id );
    const classes = useStyles();
    const [states,setStates] = useState({
        bank: Inc.defaultOwnerBank(),
        ready: false,
        yesno: "",
        error: false,
        errorName: "",
        errorCode: "",
        redirectId: 0,
        isLoading: true,
        toast: "",
    });
    const addError = (name:keyof OwnerBank,isError:boolean) =>{
        if( isError ){
            if( !errors.includes(name) ){
                errors.push( name );
            }
        } else {
            if( errors.includes(name) ){
	    		const index = errors.findIndex((v) => v===name);
		    	errors.splice(index,1);
            }
        }

        if( states.bank.bank_type_id===1 ){
            const index1 = errors.findIndex((v) => v==="bank_store");
            if( index1>=0 ){
                errors.splice(index1,1);
            }
            const index2 = errors.findIndex((v) => v==="bank_name");
            if( index2>=0 ){
                errors.splice(index2,1);
            }
        }


        if( errors.length>0 && !states.error ){
            setStates({...states,error:true});
        }
        if( errors.length===0 && states.error ){
            setStates({...states,error:false});
        }
    }
    const change = (name:keyof OwnerBank,value:string)=>{
        if( name==="bank_type_id"){
            let mes = "";
            if( value==="1" ){
                mes = "1";
                addError("bank_code",false);
            }
            setStates({...states,"bank":{...states.bank,[name]:parseInt(value),"bank_code":""},errorCode:mes});
        } else {
            setStates({...states,"bank":{...states.bank,[name]:value}});
        }
    }
    const changeNumber = (name:keyof OwnerBank,value:string)=>{
        setStates({...states,"bank":{...states.bank,[name]:Tools.toHan(value)}});
    }
    const changeCode = (index:number)=> (event: React.ChangeEvent<HTMLInputElement>) => {
        let codes:string[] = ["","",""];
        if( states.bank.bank_code ){
            const sp = states.bank.bank_code.split("-");
            if( sp.length===2 ){
                codes[0] = sp[0];
                codes[2] = sp[1];
            }
            if( sp.length===3 ){
                codes[0] = sp[0];
                codes[1] = sp[1];
                codes[2] = sp[2];
            }
        }

        codes[index-1] = Tools.toHan(event.target.value);
        if( codes[0].length>5 ){
            codes[0] = codes[0].substr(0,5);
        }
        if( codes[1].length>1 ){
            codes[1] = codes[1].substr(0,1);
        }
        if( codes[2].length>8 ){
            codes[2] = codes[2].substr(0,8);
        }

        let mes = "";
        if( codes[0]==="" || codes[2]==="" ){
            mes = "だめ";
        }
        setStates({...states,"bank":{...states.bank,"bank_code":codes.join("-").replace("--","-")},"errorCode":mes});
    }
    const blur = ()=>{
        if( states.bank.bank_name.substr(0,4)==="ゆうちょ" ){
            setStates({...states,"errorName":"ゆうちょ銀行の場合は金融機関種類を「ゆうちょ」にして下さい"});
        } else {
            setStates({...states,"errorName":""});
        }
    }
    const confirm = ()=>{
        //console.log("states",states);
        //console.log("errors",errors);
        let error = false;
        if( errors.length>0 ){
            error = true;
        }
        if( states.errorName!=="" || states.errorCode!=="" ){
            error = true;
        }    
        if( error ){
            setStates({...states,toast:"入力の不完全な欄（赤字）があります。"});
        } else {
            setStates({...states,yesno:"この内容で登録します。\nよろしいですか？"});
        }
    }
	const closeToast = ()=>{
        setStates({...states,toast:""});
	}
    const yes = ()=>{
        setStates({...states,isLoading:true});
        Ajax.send("bank/do",{bank:states.bank},(res:any)=>{
            //console.log(res);
            if( res.ok ){
                setStates({...states,redirectId:1,isLoading:false});
            }
        });
    }
    const no = ()=>{
        setStates({...states,yesno:""});
    }

    useEffect( ()=>{
        if( props.owner.owner_id>0 ){
            Ajax.send("bank/get",{},(res:any)=>{
                //console.log(res);
                if( res.ok ){
                    setStates({...states,"isLoading":false,"bank":Inc.convOwnerBank(res.bank)})
                }
            });
        } else {
            setStates({...states,"bank":Inc.defaultOwnerBank(),"isLoading":false});
        }
    } ,[]);

    if( states.isLoading ){
        return (
            <Loading isLoading={true}/>
        )
    }

    if( states.redirectId>0 || props.owner.switch_id>1 ){
        return (
            <Redirect to="/bank"/>
        )
    }


    let code1 = "";
    let code2 = "";
    let code3 = "";
    if( states.bank.bank_code && states.bank.bank_code!=="" && states.bank.bank_type_id===1 ){
        const sp = states.bank.bank_code.split("-");
        if( sp.length===2 ){
            code1 = sp[0];
            code3 = sp[1];
        }
        if( sp.length===3 ){
            code1 = sp[0];
            code2 = sp[1];
            code3 = sp[2];
        }
    }

    const inputProps = {
        startAdornment: <InputAdornment style={{whiteSpace:"nowrap"}} position="start">-</InputAdornment>,
    };

	return (
		<div id="bank_input" className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={9}>
                    <Paper className={classes.paper}>
                        <Title text="支払口座" icon="portrait"/>
                        <div style={{marginBottom:"2em"}}>
                        商品の売上を受け取る口座情報を入力して下さい。<br/>
                        </div>
                        <Hidden mdUp implementation="js">
							<BottomButtons button1='この内容で登録する' onClick1={confirm} disabled1={states.error || states.errorCode!==""} button2='登録しないで中断する' link2='/bank'/>
                        </Hidden>

                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <ColInput name="金融機関種類" value={String(states.bank.bank_type_id)} addError={addError} change={change} id="bank_type_id" type="radio" list={Inc.bankTypes} required/>
                            </Grid>
                            {states.bank.bank_type_id===1 ? (
                            <React.Fragment>
                                <Grid item xs={12}>
                                    <FormControl fullWidth={true} error={states.errorCode!==""} style={{marginBottom:"1.5em"}}>
                                        <FormLabel component="label" className={classes.formLabel}>口座番号<span className="formRequired">必須</span></FormLabel>
                                        <FormGroup row>
                                            <TextField
                                                id="code1"
                                                value={code1}
                                                onChange={changeCode(1)}
                                                placeholder="記号"
                                                margin="dense"
												variant='standard'
                                                style={{width:"6em"}}
                                            />
                                            <TextField
                                                id="code2"
                                                value={code2}
                                                onChange={changeCode(2)}
                                                margin="dense"
                                                InputProps={inputProps}
												variant='standard'
                                                style={{width:"4em"}}
                                            />
                                            <TextField
                                                id="code3"
                                                value={code3}
                                                onChange={changeCode(3)}
                                                margin="dense"
                                                InputProps={inputProps}
                                                placeholder="番号"
												variant='standard'
                                                style={{width:"8em"}}
                                            />
                                        </FormGroup>
                                        {states.errorCode!=="" &&
                                            <FormHelperText>※記号と番号は省略できません</FormHelperText>
                                        }
                                        <FormHelperText>※記号と番号の間に1桁の数字がない場合は、真ん中の入力欄は空欄にしてください</FormHelperText>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                    <ColInput name="口座名義" value={states.bank.bank_signature} addError={addError} change={change} maxLength={30} id="bank_signature" type="text" required/>
                                </Grid>
                            </React.Fragment>
                            ):(
                            <React.Fragment>
                                <Grid item xs={6}>
                                    <ColInput name="金融機関名" error={states.errorName} value={states.bank.bank_name} addError={addError} change={change} blur={blur} maxLength={30} id="bank_name" type="text" required/>
                                </Grid>
                                <Grid item xs={6}>
                                    <ColInput name="支店名" value={states.bank.bank_store} addError={addError} change={change} maxLength={30} id="bank_store" type="text" required/>
                                </Grid>
                                <Grid item xs={12}>
                                    <ColInput name="口座種目" value={String(states.bank.bank_cat_id)} addError={addError} change={change} id="bank_cat_id" type="radio" list={Inc.bankCats} required/>
                                </Grid>
                                <Grid item xs={6}>
                                    <ColInput name="口座番号" value={states.bank.bank_code} addError={addError} change={changeNumber} maxLength={7} id="bank_code" type="text" required/>
                                </Grid>
                                <Grid item xs={6}>
                                    <ColInput name="口座名義" value={states.bank.bank_signature} addError={addError} change={change} maxLength={30} id="bank_signature" type="text" required/>
                                </Grid>
                            </React.Fragment>
                            )}
                        </Grid>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={3}>
                    <Paper className={classes.paper}>
                        <Title text="管理情報" size={2}/>
                        <RowData name="作家名" value={props.owner.owner_name}/>
                        <RowData name="会員名" value={props.owner.customer.name}/>
						<Divider style={{margin:"1em 0"}}/>
						<div>
							<div style={{color:'#666666'}}>メールアドレス</div>
							<div className={classes.yourMail}>{props.owner.customer.mail}</div>
						</div>
                        <Hidden mdDown implementation="js">
                            <Divider style={{margin:"1em 0"}}/>
                            <Grid container spacing={1}>
                                <Grid item xs={12} lg={12}>
                                    <Button variant="contained" color="primary" style={{width:"100%"}} onClick={confirm} disabled={states.error || states.errorCode!==""}>この内容で登録する</Button>
                                </Grid>
                                <Grid item xs={12} lg={12}>
                                    <Link to="/bank"><Button variant="outlined" style={{width:"100%"}}>登録しないで中断する</Button></Link>
                                </Grid>
                            </Grid>
                        </Hidden>
                    </Paper>
                </Grid>
            </Grid>
            <Yesno mes={states.yesno} yes={yes} no={no} isOpen={states.yesno!==""}/>
            <Toast close={closeToast} mes={states.toast}/>
		</div>
	);
}

export default BankInput;
